import { render } from "./BaseBalloon.vue?vue&type=template&id=8c462214"
import script from "./BaseBalloon.vue?vue&type=script&lang=js"
export * from "./BaseBalloon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__